import Vue from "vue";
import Router from "vue-router";
import StarterPage from "./pages/starter/StarterPage.vue";
import PrivacyPage from "./pages/starter/PrivacyPage.vue";
import DocumentationPageIOS from "./pages/starter/DocumentationPageIOS.vue";
import BeatlengthPage from "./pages/beatlength/BeatlengthPage.vue";
import DocumentationPageAndroid from "./pages/starter/DocumentationPageAndroid.vue";
import RemoteHornPage from "./pages/starter/RemoteHornPage.vue";
import StarterNavbar from "./layout/StarterNavbar.vue";
import StarterFooter from "./layout/StarterFooter.vue";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "starter",
            components: {default: StarterPage, header: StarterNavbar, footer: StarterFooter},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        },
        {
            path: "/app",
            name: "app",
            redirect: "/"
        },

        {
            path: "/app/beatlengthcalculator",
            name: "beatlength-calculator-app",
            redirect: "/beatlength"
        },
        {
            path: "/beatlengthcalculator",
            name: "beatlength-calculator",
            redirect: "/beatlength"
        },
        {
            path: "/starttimer",
            name: "starttimer",
            redirect: "/"
        },
        {
            path: "/starttimerapp",
            name: "starttimerapp",
            redirect: "/"
        },
        {
            path: "/app/starttimer",
            name: "starttimerapp-app",
            redirect: "/"
        },
        {
            path: "/documentation",
            name: "documentation",
            redirect: "/documentation/ios/"
        },
        {
            path: "/beatlength",
            name: "beatlength",
            components: {header: StarterNavbar, footer: StarterFooter, default: BeatlengthPage},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        },
        {
            path: "/documentation/ios/",
            name: "documentation-ios",
            components: {header: StarterNavbar, footer: StarterFooter, default: DocumentationPageIOS},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        },
        {
            path: "/documentation/android/",
            name: "documentation-android",
            components: {header: StarterNavbar, footer: StarterFooter, default: DocumentationPageAndroid},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        },
        {
            path: "/remote-horn/",
            name: "remote horn",
            components: {default: RemoteHornPage, header: StarterNavbar, footer: StarterFooter},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        },
        {
            path: "/privacy-policy/",
            name: "privacy policy",
            components: {default: PrivacyPage, header: StarterNavbar, footer: StarterFooter},
            props: {
                footer: {backgroundColor: 'black'},
                header: {colorOnScroll: 0, transparent: false}
            }
        }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return {x: 0, y: 0}
        }
    },
});
